import { isMobile } from '../../../../src/js/utils/is-mobile';

const collapse = () => {
  // Accordion collapse
  $('.js-collapse-heading').on('click', function (e) {
    var that = $(this);

    var dropDown = $(this).parent().find('.js-collapse-content');
    $('.js-collapse-content').not(dropDown).slideUp(100);

    if ($(this).hasClass('is-active')) {
      $(this).removeClass('is-active');
    } else {
      $('.js-collapse-heading.is-active').removeClass('is-active');
      $(this).addClass('is-active');
    }

    setTimeout(function () {
      dropDown.stop(false, true).slideToggle(300, function () {
        var offset = $(that).offset().top;
        var headerH = isMobile() ? $('.site-header .navbar').innerHeight() : 0;
        $('html, body').animate({
          scrollTop: offset - headerH
        }, 500, 'swing');
      });
    }, 200);
    e.preventDefault();
  });
};

export default collapse;
